<template>
  <div class="Index">
    <div class="window_bg"></div>
    <div class="haerd">
      <div class="haerd_left">
        <div class="backBtn" @click.stop.prevent="goBack">返 回</div>
        <div class="title">让我们认识一下常见的图标</div>
      </div>
    </div>
    <div class="module_box">
      <div class="module" @click.stop.prevent="goYadd">
        <div class="icon1"></div>
        <div class="left_text">圆形加号</div>
      </div>
      <div class="module" @click.stop.prevent="goFadd">
        <div class="icon2"></div>
        <div class="left_text">方形加号</div>
      </div>
      <div class="module" @click.stop.prevent="goMessage">
        <div class="icon3"></div>
        <div class="left_text">消息符号</div>
      </div>
      <div class="module" @click.stop.prevent="goPosition">
        <div class="icon4"></div>
        <div class="left_text">定位图标</div>
      </div>
      <div class="module" @click.stop.prevent="goQRcode">
        <div class="icon5"></div>
        <div class="left_text">二维码</div>
      </div>
      <div class="module" @click.stop.prevent="goScanCode">
        <div class="icon6"></div>
        <div class="left_text">扫码符号</div>
      </div>
      <div class="module" @click.stop.prevent="goVoice">
        <div class="icon7"></div>
        <div class="left_text">语音符号</div>
      </div>
      <div class="module" @click.stop.prevent="goSet">
        <div class="icon8"></div>
        <div class="left_text">设置符号</div>
      </div>
      <div class="module" @click.stop.prevent="goSearch">
        <div class="icon9"></div>
        <div class="left_text">搜索符号</div>
      </div>
      <div class="module" @click.stop.prevent="goShoppingCart">
        <div class="icon10"></div>
        <div class="left_text">购物车</div>
      </div>
      <div class="module" @click.stop.prevent="goUse">
        <div class="icon11"></div>
        <div class="left_text">个人中心</div>
      </div>
      <div class="module" @click.stop.prevent="goLove">
        <div class="icon12"></div>
        <div class="left_text">点赞符号</div>
      </div>
      <div class="module" @click.stop.prevent="goShare">
        <div class="icon13"></div>
        <div class="left_text">分享符号</div>
      </div>
      <div class="module" @click.stop.prevent="goCollect">
        <div class="icon14"></div>
        <div class="left_text">收藏符号</div>
      </div>
      <div class="module" @click.stop.prevent="goCall">
        <div class="icon15"></div>
        <div class="left_text">呼叫符号</div>
      </div>
      <div class="module" @click.stop.prevent="goPhoto">
        <div class="icon16"></div>
        <div class="left_text">拍摄符号</div>
      </div>
      <div class="module" @click.stop.prevent="goService">
        <div class="icon17"></div>
        <div class="left_text">客服符号</div>
      </div>
      <div class="module" @click.stop.prevent="goClose">
        <div class="icon18"></div>
        <div class="left_text">关闭符号</div>
      </div>
      <div class="module" @click.stop.prevent="goReturn">
        <div class="icon19"></div>
        <div class="left_text">返回符号</div>
      </div>
      <div class="module" @click.stop.prevent="goExpression">
        <div class="icon20"></div>
        <div class="left_text">表情包</div>
      </div>
      <div class="module" @click.stop.prevent="goFace">
        <div class="icon21"></div>
        <div class="left_text">人脸识别</div>
      </div>
      <div class="module" @click.stop.prevent="goCar">
        <div class="icon22"></div>
        <div class="left_text">打车符号</div>
      </div>
      <div class="module" @click.stop.prevent="goNavigation">
        <div class="icon23"></div>
        <div class="left_text">导航符号</div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'iconIndex',
  components: {},
  data () {
    return {}
  },
  created () {},

  mounted () {},
  beforeDestroy () {},

  methods: {
    async goBack () {
      this.$router.replace({
        path: '/recognize/recognizeIndex'
      })
    },
    async goYadd () {
      this.$router.push({
        path: '/recognize/icon/yadd/index1'
      })
    },
    async goFadd () {
      this.$router.push({
        path: '/recognize/icon/fadd/index1'
      })
    },
    async goMessage () {
      this.$router.push({
        path: '/recognize/icon/message/index1'
      })
    },
    async goQRcode () {
      this.$router.push({
        path: '/recognize/icon/QRcode/index1'
      })
    },
    async goPosition () {
      this.$router.push({
        path: '/recognize/icon/position/index1'
      })
    },
    async goScanCode () {
      this.$router.push({
        path: '/recognize/icon/scanCode/index1'
      })
    },
    async goVoice () {
      this.$router.push({
        path: '/recognize/icon/voice/index1'
      })
    },
    async goSet () {
      this.$router.push({
        path: '/recognize/icon/set/index1'
      })
    },
    async goSearch () {
      this.$router.push({
        path: '/recognize/icon/search/index1'
      })
    },
    async goShoppingCart () {
      this.$router.push({
        path: '/recognize/icon/shoppingCart/index1'
      })
    },
    async goUse () {
      this.$router.push({
        path: '/recognize/icon/use/index1'
      })
    },
    async goLove () {
      this.$router.push({
        path: '/recognize/icon/love/index1'
      })
    },
    async goShare () {
      this.$router.push({
        path: '/recognize/icon/share/index1'
      })
    },
    async goCollect () {
      this.$router.push({
        path: '/recognize/icon/collect/index1'
      })
    },
    async goCall () {
      this.$router.push({
        path: '/recognize/icon/call/index1'
      })
    },
    async goCar () {
      this.$router.push({
        path: '/recognize/icon/car/index1'
      })
    },
    async goNavigation () {
      this.$router.push({
        path: '/recognize/icon/navigation/index1'
      })
    },
    async goFace () {
      this.$router.push({
        path: '/recognize/icon/face/index1'
      })
    },
    async goPhoto () {
      this.$router.push({
        path: '/recognize/icon/photo/index1'
      })
    },
    async goExpression () {
      this.$router.push({
        path: '/recognize/icon/expression/index1'
      })
    },
    async goReturn () {
      this.$router.push({
        path: '/recognize/icon/return/index1'
      })
    },
    async goClose () {
      this.$router.push({
        path: '/recognize/icon/close/index1'
      })
    },
    async goService () {
      this.$router.push({
        path: '/recognize/icon/service/index1'
      })
    }
  }
}
</script>

<style scoped lang="less">
.Index {
  position: relative;
  width: 100%;
  height: 100%;
  background: linear-gradient(180.00deg, rgb(95, 141, 255) 6.107%,rgb(144, 181, 252) 39.695%,rgb(217, 240, 255) 99.237%);
  border-radius: 0px;
  .window_bg {
    pointer-events: none; /* 使点击穿透该元素 */
    position: absolute;
    top: -50px;
    left: -50px;
    width: 630px;
    height: 684px;
    background: url(@/assets/use/useIndex/window_bg.png) no-repeat center;
    background-size: 100% 100%;

  }
}
.haerd {
  padding: 40px 30px;
  //   display: flex;
  //   align-items: flex-end;
  //   justify-content: space-between;
  .haerd_left {
    position: relative;
    z-index: 1;
    .backBtn {
      cursor: pointer;
      width: 251px;
      height: 90px;
      background: url(@/assets/use/useIndex/backBtn.png) no-repeat center;
      background-size: 100% 100%;
      font-family: Microsoft YaHei;
      font-weight: bold;
      font-size: 40px;
      color: #ffffff;
      display: flex;
      justify-content: center;
      align-items: center;
      text-shadow: 0px 1px 5px rgba(200, 121, 0, 0.5);
      border-radius: 96.5px;
      box-shadow: 0px 6px 12px 1px rgba(182, 118, 118, 0.27);
    }
    .title {
      text-align: center;
      margin-top: 41px;
      // margin-left: 20px;
      font-family: SourceHanSansSC-Regular-2;
      font-weight: bold;
      font-size: 45px;
      //   width: 420px;
      color: #ffffff;
      // line-height: 82px;
    }
  }
}

.module_box {
  width: 100%;
  max-height: 73vh;
  // display: flex;
  // overflow-y: auto;
  // justify-content:space-evenly;
  // flex-wrap: wrap;
  overflow-y: auto;
  display: grid;
    justify-content: space-between;
    justify-items: center;
    grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
    grid-gap: 10px 1px;

  .module {
    cursor: pointer;
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: center;
    width: 200px;
    height: 168px;
    margin-bottom: 35px;
    border-radius: 15px;
    box-shadow: inset 0px 7px 38px 13px rgba(164, 195, 253, 0.38);
    background: rgb(255, 255, 255);
    .left_text {
      margin-top: 10px;
      font-family: SourceHanSansSC-Regular-2;
      font-weight: 500;
      font-size: 32px;
      color: rgb(51, 51, 51);
      line-height: 39px;
    }
    .icon1 {
      width: 90px;
      height: 90px;
      background: url(@/assets/recognize/icon/iconIndex/yadd.png) no-repeat center;
      background-size: 100% 100%;
    }
    .icon2 {
      width: 90px;
      height: 90px;
      background: url(@/assets/recognize/icon/iconIndex/fadd.png) no-repeat center;
      background-size: 100% 100%;
    }
    .icon3 {
      width: 90px;
      height: 90px;
      background: url(@/assets/recognize/icon/iconIndex/message.png) no-repeat center;
      background-size: 100% 100%;
    }
    .icon4 {
      width: 90px;
      height: 90px;
      background: url(@/assets/recognize/icon/iconIndex/position.png) no-repeat center;
      background-size: 100% 100%;
    }
    .icon5 {
      width: 90px;
      height: 90px;
      background: url(@/assets/recognize/icon/iconIndex/QRcode.png) no-repeat center;
      background-size: 100% 100%;
    }
    .icon6 {
      width: 90px;
      height: 90px;
      background: url(@/assets/recognize/icon/iconIndex/scanCode.png) no-repeat center;
      background-size: 100% 100%;
    }
    .icon7 {
      width: 90px;
      height: 90px;
      background: url(@/assets/recognize/icon/iconIndex/voice.png) no-repeat center;
      background-size: 100% 100%;
    }
    .icon8 {
      width: 90px;
      height: 90px;
      background: url(@/assets/recognize/icon/iconIndex/set.png) no-repeat center;
      background-size: 100% 100%;
    }
    .icon9 {
      width: 90px;
      height: 90px;
      background: url(@/assets/recognize/icon/iconIndex/search.png) no-repeat center;
      background-size: 100% 100%;
    }
    .icon10 {
      width: 90px;
      height: 90px;
      background: url(@/assets/recognize/icon/iconIndex/shoppingCart.png) no-repeat center;
      background-size: 100% 100%;
    }
    .icon11 {
      width: 90px;
      height: 90px;
      background: url(@/assets/recognize/icon/iconIndex/use.png) no-repeat center;
      background-size: 100% 100%;
    }
    .icon12 {
      width: 90px;
      height: 90px;
      background: url(@/assets/recognize/icon/iconIndex/love.png) no-repeat center;
      background-size: 100% 100%;
    }
    .icon13 {
      width: 90px;
      height: 90px;
      background: url(@/assets/recognize/icon/iconIndex/share.png) no-repeat center;
      background-size: 100% 100%;
    }
    .icon14 {
      width: 90px;
      height: 90px;
      background: url(@/assets/recognize/icon/iconIndex/collect.png) no-repeat center;
      background-size: 100% 100%;
    }
    .icon15 {
      width: 90px;
      height: 90px;
      background: url(@/assets/recognize/icon/iconIndex/call.png) no-repeat center;
      background-size: 100% 100%;
    }
    .icon16 {
      width: 90px;
      height: 90px;
      background: url(@/assets/recognize/icon/iconIndex/clap.png) no-repeat center;
      background-size: 100% 100%;
    }
    .icon17 {
      width: 90px;
      height: 90px;
      background: url(@/assets/recognize/icon/iconIndex/service.png) no-repeat center;
      background-size: 100% 100%;
    }
    .icon18 {
      width: 90px;
      height: 90px;
      background: url(@/assets/recognize/icon/iconIndex/close.png) no-repeat center;
      background-size: 100% 100%;
    }
    .icon19 {
      width: 90px;
      height: 90px;
      background: url(@/assets/recognize/icon/iconIndex/back.png) no-repeat center;
      background-size: 100% 100%;
    }
    .icon20 {
      width: 90px;
      height: 90px;
      background: url(@/assets/recognize/icon/iconIndex/expression.png) no-repeat center;
      background-size: 100% 100%;
    }
    .icon21 {
      width: 90px;
      height: 90px;
      background: url(@/assets/recognize/icon/iconIndex/face.png) no-repeat center;
      background-size: 100% 100%;
    }
    .icon22 {
      width: 90px;
      height: 90px;
      background: url(@/assets/recognize/icon/iconIndex/car.png) no-repeat center;
      background-size: 100% 100%;
    }
    .icon23 {
      width: 90px;
      height: 90px;
      background: url(@/assets/recognize/icon/iconIndex/navigation.png) no-repeat center;
      background-size: 100% 100%;
    }
  }
}
</style>
